import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Montserrat', sans-serrif;
    }
    html, body{
        overflow-x: hidden;
    }
    ::-webkit-scrollbar {
        width: 10px;
      }
      
      /* Track */
      ::-webkit-scrollbar-track {
        background: #f1f1f1; 
        border-radius: 2px;
      }
       
      /* Handle */
      ::-webkit-scrollbar-thumb {
        background:  #3d3d3d;
        border-radius: 2px; 
      }
      
      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: #555; 
      }
`;

export default GlobalStyles;